export default basePath => ({
  ativar: { method: 'PUT', url: `${basePath}/ativacao/{id}/true` },
  atualizar: { method: 'PUT', url: `${basePath}` },
  gravar: { method: 'POST', url: `${basePath}` },
  inativar: { method: 'PUT', url: `${basePath}/ativacao/{id}/false` },
  listar: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}` },
  listarAtivos: { method: 'GET', url: `${basePath}?nome={nome}&indAtivo=true` },
  selecao: { method: 'GET', url: `${basePath}/selecao` },
});



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/generic-resource.js